export default __webpack_public_path__ + "static/media/bg.2238ebe8.jpg";